import React from "react";
import { HashRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import About from "./components/About";
import HashRouting from "./components/HashRouting";
import RelativePaths from "./components/RelativePaths";
import Deploy from "./components/Deploy";
import ViewCode from "./components/ViewCode";
import "./components/Styles.css";

const App = () => {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/hash-routing">Hash Routing</Link>
            </li>
            <li>
              <Link to="/relative-paths">Relative Paths</Link>
            </li>
            <li>
              <Link to="/deploy">Deploy</Link>
            </li>
            <li>
              <Link to="/view-code">View Code</Link>
            </li>
          </ul>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/hash-routing" element={<HashRouting />} />
          <Route path="/relative-paths" element={<RelativePaths />} />
          <Route path="/deploy" element={<Deploy />} />
          <Route path="/view-code" element={<ViewCode />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
